(function () {
  // Detect Meta In-App Browser (Facebook & Instagram)
  var ua = navigator.userAgent || '';
  var isMetaIAB = /FBAN|FBAV|Instagram|FB_IAB|FBIOS|FB4A/.test(ua);

  // FIX 1: Remove the view-transition render blocker immediately
  // The Horizon theme adds <link id="view-transition-render-blocker" blocking="render">
  // but the script that removes it is disabled, so pages can get stuck.
  function removeRenderBlocker() {
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker) blocker.remove();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRenderBlocker);
  } else {
    removeRenderBlocker();
  }
  setTimeout(removeRenderBlocker, 500);

  // FIX 2: Disable View Transitions in Meta IAB (causes blank pages on iOS)
  if (isMetaIAB && document.startViewTransition) {
    document.startViewTransition = function (callback) {
      if (typeof callback === 'function') callback();
      return {
        ready: Promise.resolve(),
        finished: Promise.resolve(),
        updateCallbackDone: Promise.resolve(),
        skipTransition: function () {}
      };
    };
  }

  // FIX 3: Fix target="_blank" external links that silently fail in Meta IAB
  if (isMetaIAB) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href && !href.startsWith('/') && !href.includes('25wearing.com') && !href.includes('shopify.com')) {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
      });
    });
  }

  // FIX 4: Patch sessionStorage if blocked by Meta IAB on iOS
  try {
    sessionStorage.setItem('__test__', '1');
    sessionStorage.removeItem('__test__');
  } catch (e) {
    var mem = {};
    Object.defineProperty(window, 'sessionStorage', {
      value: {
        getItem: function (k) { return mem[k] !== undefined ? mem[k] : null; },
        setItem: function (k, v) { mem[k] = String(v); },
        removeItem: function (k) { delete mem[k]; },
        clear: function () { mem = {}; },
        key: function (i) { return Object.keys(mem)[i] || null; },
        get length() { return Object.keys(mem).length; }
      },
      writable: false
    });
  }

  // FIX 5: Add 'Open in browser' banner for Meta IAB users
  // Meta IAB checkout redirects often fail. Prompt user to open in real browser.
  if (isMetaIAB) {
    document.addEventListener('DOMContentLoaded', function () {
      var banner = document.createElement('div');
      banner.id = 'meta-iab-banner';
      banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#1e2d4e;color:#fff;text-align:center;padding:10px 16px;font-size:13px;font-family:sans-serif;display:flex;align-items:center;justify-content:space-between;gap:8px;';
      var msg = document.createElement('span');
      msg.textContent = 'For the best shopping experience, open in your browser.';
      var btn = document.createElement('a');
      btn.href = window.location.href;
      btn.target = '_system';
      btn.style.cssText = 'background:#a8c8e8;color:#1e2d4e;padding:6px 14px;border-radius:20px;text-decoration:none;font-weight:bold;white-space:nowrap;font-size:12px;flex-shrink:0;';
      btn.textContent = 'Open Browser';
      var close = document.createElement('span');
      close.textContent = '\u00d7';
      close.style.cssText = 'cursor:pointer;font-size:18px;padding:0 4px;flex-shrink:0;';
      close.onclick = function () { banner.remove(); };
      banner.appendChild(msg);
      banner.appendChild(btn);
      banner.appendChild(close);
      document.body.insertBefore(banner, document.body.firstChild);
      // Push down the page content
      document.body.style.paddingTop = (document.body.style.paddingTop || '0px');
    });
  }

})();
